/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { createLoadingSelector, createErrorSelector, errorActions } from "@a1/core";
import { processActions } from "../../reducer/processReducer";

import logoSplash from "../../images/logo_splash.png";

const actionsNames = ["CHECK_PAIR", "PROCESS_USER"];

class RegistrationStart extends Component {
  state = {
    password: "",
    passwordError: "",
    password2: "",
    password2Error: "",
    msisdn: "",
    msisdnError: "",
    pid: "",
    pidError: "",
    mustValidateData: false,
    planAcceptView: false,
    planAcceptChecked: false,
  };

  componentDidMount() {
    document.title = "Данни за абонамент  - A1 Xplore TV GO";

    const { history, process, resetUserData, clearErrors } = this.props;

    clearErrors(actionsNames);

    if (!(process.token && process.token.length)) {
      history.push("/confirm");
      return false;
    }

    resetUserData();

    this.handleAutofocus();
    return false;
  }

  componentDidUpdate(prevProps) {
    const { loading, history, process, error } = this.props;

    if (
      !loading &&
      !(error && error.length) &&
      !(process.checkPairResult && process.checkPairResult.error) &&
      !(process.processUserResult && process.processUserResult.error)
    ) {
      if (
        (process.isNew === true &&
          process.checkPairResult &&
          process.checkPairResult.isOk === true &&
          process.checkPairResult !== prevProps.process.checkPairResult) ||
        (process.isNew === false &&
          ((process.password !== null && process.password !== prevProps.process.password) ||
            (process.processUserResult !== null && process.processUserResult !== prevProps.process.processUserResult)))
      ) {
        if (process.isNew === true) {
          if (process.isAddon === true) {
            history.push("/addon");
          } else {
            history.push("/preview");
          }
        } else if (process.isEligible !== true && process.isAddon === true) {
          history.push("/addon");
        } else if (process.isEligible === true && process.isAddon !== true) {
          if (
            process.processUserResult &&
            process.processUserResult.isOk === true &&
            process.processUserResult !== prevProps.process.processUserResult
          ) {
            history.push("/finish");
          }
        }
      }
    }

    return false;
  }

  handlePlanAcceptClick = event => {
    if (event.target.tagName.toLowerCase() === "a") return false;
    const { planAcceptChecked } = this.state;
    this.setState({ planAcceptChecked: !planAcceptChecked });
    return false;
  };

  handleInputChange = event => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    const { mustValidateData } = this.state;

    this.setState({
      [name]: value,
    });

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleInputOnKeyUp = event => {
    const { mustValidateData } = this.state;

    if (event.keyCode === 13) {
      this.handleNextClick();
    }

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleAutofocus = () => {
    const autofocusElements = document.getElementsByClassName("autofocus");
    if (autofocusElements && autofocusElements.length > 0) {
      autofocusElements[0].focus();
    }
  };

  handleInpOnClick = event => {
    event.target.previousSibling.focus();
  };

  handleInpOnFocus = event => {
    event.currentTarget.parentNode.classList.add("active");
  };

  handleInpOnBlur = event => {
    const targetCurrent = event.target;
    const targetParent = targetCurrent.parentNode;
    if (!targetCurrent.value.length) {
      targetParent.classList.remove("active");
    }
  };

  handlePassShowHide = event => {
    const targetCurrent = event.target;
    const targetInput = targetCurrent.previousSibling.previousSibling;
    if (targetInput.type.toLowerCase() === "password") {
      targetInput.type = "text";
      targetCurrent.classList.add("show");
    } else {
      targetInput.type = "password";
      targetCurrent.classList.remove("show");
    }
  };

  handleNextClick = () => {
    const { msisdn, pid, password, mustValidateData, planAcceptView, planAcceptChecked } = this.state;
    const { process, setUserData, checkPair, processUser } = this.props;

    if (!mustValidateData) {
      this.setState({ mustValidateData: true });
    }

    if (this.validateData()) {
      setUserData(msisdn, pid, password);

      if (process.isNew === true) {
        checkPair(msisdn, pid, process.token);
      } else if (process.isEligible === true) {
        if (planAcceptView === true) {
          if (planAcceptChecked) {
            processUser(
              process.email !== null ? process.email : "",
              process.token !== null ? process.token : "",
              password,
              pid,
              msisdn,
              process.isAddon === true,
            );
          }
        } else {
          this.setState({ planAcceptView: true });
        }
      }
    }

    return false;
  };

  validateData = () => {
    const { password, password2, msisdn, pid } = this.state;
    const { process } = this.props;

    let isValidPassword = true;
    let isValidPassword2 = true;
    let isValidMsisdn = true;
    let isValidPid = true;

    if (!(password.length > 0)) {
      isValidPassword = false;
      this.setState({
        passwordError: "Въведената парола е грешна. Паролата трябва да съдържа минимум 4 символа, без интервали.",
      });
    } else if (password.length < 4) {
      isValidPassword = false;
      this.setState({
        passwordError: "Паролата трябва да съдържа минимум 4 символа, без интервали. Моля, опитай отново.",
      });
    }
    if (isValidPassword) this.setState({ passwordError: "" });

    if (!(password2.length > 0)) {
      isValidPassword2 = false;
      this.setState({ password2Error: "Моля, въведи отново паролата си." });
    } else if (password !== password2) {
      isValidPassword2 = false;
      this.setState({
        password2Error: "Въведените пароли не съвпадат. Моля, въведи ги отново.",
      });
    }
    if (isValidPassword2) this.setState({ password2Error: "" });

    if (process.isNew === true) {
      if (msisdn.length > 0) {
        const reMsisdn = /^\d+$/;
        if (!reMsisdn.test(msisdn)) {
          isValidMsisdn = false;
          this.setState({
            msisdnError:
              "Полето трябва да съдържа само цифри - 12 символа за номер на фиксирана услуга и 10 за мобилен номер.",
          });
        } else {
          const msisdnFirstSign = msisdn.substr(0, 1);

          if (msisdnFirstSign === "0" || msisdnFirstSign === "1" || msisdnFirstSign === "2") {
            if (msisdnFirstSign === "0") {
              if (msisdn.length !== 10) {
                isValidMsisdn = false;
                this.setState({
                  msisdnError: "Полето трябва да съдържа 10 цифри",
                });
              }
            } else if (msisdnFirstSign === "1" || msisdnFirstSign === "2") {
              if (msisdn.length !== 12) {
                isValidMsisdn = false;
                this.setState({
                  msisdnError: "Полето трябва да съдържа 12 цифри",
                });
              }
            }
          } else {
            isValidMsisdn = false;
            this.setState({
              msisdnError: "Полето трябва да започва с 0, 1 или 2",
            });
          }
        }
      } else {
        isValidMsisdn = false;
        this.setState({
          msisdnError:
            "Въведи номер на фиксирана услуга или мобилен номер от мрежата на А1, към който използваш услугата Xplore TV GO.",
        });
      }
      if (isValidMsisdn) this.setState({ msisdnError: "" });

      if (pid.length > 0) {
        const rePid = /^[a-zA-Z0-9]{9,13}$/;
        if (!rePid.test(pid)) {
          isValidPid = false;
          this.setState({
            pidError: "Невалидно ЕГН/БУЛСТАТ",
          });
        }
      } else {
        isValidPid = false;
        this.setState({ pidError: "Въведи ЕГН/БУЛСТАТ" });
      }
      if (isValidPid) this.setState({ pidError: "" });
    }

    return isValidPassword && isValidPassword2 && isValidMsisdn && isValidPid;
  };

  render() {
    const {
      password,
      password2,
      msisdn,
      pid,
      passwordError,
      password2Error,
      msisdnError,
      pidError,
      planAcceptView,
      planAcceptChecked,
    } = this.state;

    const { process, loading, error } = this.props;
    const requestError = error && error.length ? error.map(err => <p>{err}</p>) : null;

    const divLoading = loading ? (
      <div className="loading">
        <div className="spinner-border" />
      </div>
    ) : null;

    let divError = null;
    if (requestError) divError = requestError;
    else if (process.token && process.token.error) divError = process.token.error;
    else if (process.checkPairResult && process.checkPairResult.error) divError = process.checkPairResult.error;
    else if (process.processUserResult && process.processUserResult.error) divError = process.processUserResult.error;

    divError = divError ? <div className="error error-main">{divError}</div> : null;

    const divPasswordError = passwordError ? <div className="error">{passwordError}</div> : null;
    const divPassword2Error = password2Error ? <div className="error">{password2Error}</div> : null;
    const divMsisdnError = msisdnError ? <div className="error">{msisdnError}</div> : null;
    const divPidError = pidError ? <div className="error">{pidError}</div> : null;

    let divNew = null;
    let divHelp = null;

    divNew =
      process.isNew === true ? (
        <>
          <h1 className="tag-title">Данни за абонамент</h1>

          {divError}

          <div className="tag-textfield">
            <input
              type="text"
              name="msisdn"
              id="msisdn"
              className="tag-input"
              maxLength="12"
              value={msisdn}
              onFocus={this.handleInpOnFocus}
              onBlur={this.handleInpOnBlur}
              onChange={this.handleInputChange}
              onKeyUp={this.handleInputOnKeyUp}
            />
            <label htmlFor="msisdn" onClick={this.handleInpOnClick}>
              Номер на услуга или мобилен номер
            </label>
            <div style={{ fontSize: "12px" }}>
              За да получиш номер на ТВ или Интернет услуга, изпрати SMS на безплатен номер 1590 с текст "Internet" или
              "TV".
            </div>
            {divMsisdnError}
          </div>

          <div className="tag-textfield">
            <input
              type="text"
              name="pid"
              id="pid"
              className="tag-input"
              maxLength="13"
              value={pid}
              onFocus={this.handleInpOnFocus}
              onBlur={this.handleInpOnBlur}
              onChange={this.handleInputChange}
              onKeyUp={this.handleInputOnKeyUp}
            />
            <label htmlFor="pid" onClick={this.handleInpOnClick}>
              ЕГН/БУЛСТАТ
            </label>
            {divPidError}
          </div>
        </>
      ) : (
        <>
          <h1 className="tag-title">Въведи нова парола</h1>

          {divError}
        </>
      );

    divHelp = process.isNew ? (
      <div className="tag-content tag-content__help">
        Не успяваш да откриеш номер на услуга?{" "}
        <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
          Помощ
        </a>
      </div>
    ) : (
      <div className="tag-content tag-content__help">
        Имаш въпроси?{" "}
        <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
          Помощ
        </a>
      </div>
    );

    let containerBody = null;

    if (process.token) {
      if (planAcceptView === true) {
        containerBody = (
          <div className="container-body">
            <h1 className="tag-title">Правила за ползване</h1>
            {divError}
            <div className="tag-content">
              <div className="tag-checkbox" style={{ margin: "60px 0 40px" }} onClick={this.handlePlanAcceptClick}>
                <input type="checkbox" name="planAccept" id="planAccept" checked={planAcceptChecked} readOnly />
                <span className="tag-checkbox__span">
                  Приемам&nbsp;
                  <NavLink to="/pravila-za-polzvane" className="tag-color-red" target="_blank">
                    правилата за ползване
                  </NavLink>
                </span>
              </div>
            </div>

            <div className="tag-content">
              <button
                type="button"
                className={planAcceptChecked ? "tag-btn tag-btn--active" : "tag-btn tag-btn--inactive"}
                onClick={this.handleNextClick}
                disabled={!!loading}
              >
                OK
              </button>
            </div>

            <div className="tag-content" style={{ marginTop: "40px" }}>
              A1 Xplore TV GO е услуга предназначена за частни потребители и по никакъв начин не трябва да се използва
              за бизнес цели или публични демонстрации.
            </div>
          </div>
        );
      } else {
        containerBody = (
          <div className="container-body">
            {divNew}

            <div className="tag-textfield">
              <input
                name="password"
                type="password"
                id="password"
                className="tag-input"
                value={password}
                onFocus={this.handleInpOnFocus}
                onBlur={this.handleInpOnBlur}
                onChange={this.handleInputChange}
                onKeyUp={this.handleInputOnKeyUp}
              />
              <label htmlFor="password" onClick={this.handlePassOnClick}>
                Парола
              </label>
              <div className="tag-textfield_hide_show" onClick={this.handlePassShowHide} />
              {divPasswordError}
            </div>

            <div className="tag-textfield">
              <input
                name="password2"
                type="password"
                id="password2"
                className="tag-input"
                value={password2}
                onFocus={this.handleInpOnFocus}
                onBlur={this.handleInpOnBlur}
                onChange={this.handleInputChange}
                onKeyUp={this.handleInputOnKeyUp}
              />
              <label htmlFor="password2" onClick={this.handlePassOnClick}>
                Повтори паролата
              </label>
              <div className="tag-textfield_hide_show" onClick={this.handlePassShowHide} />
              {divPassword2Error}
            </div>

            <div className="tag-content" style={{ marginTop: "80px" }}>
              <button
                type="button"
                className="tag-btn tag-btn--active"
                onClick={this.handleNextClick}
                disabled={!!loading}
              >
                Продължи
              </button>
            </div>

            {divHelp}
          </div>
        );
      }
    }
    return (
      <div className="page page-register">
        <div className="header-bg" />

        <div className="container container--small">
          {divLoading}

          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>

          {containerBody}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
    loading: createLoadingSelector(actionsNames)(state),
    error: createErrorSelector(actionsNames)(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearErrors: actions => dispatch(errorActions.clearErrors(actions)),
    setUserData: (msisdn, pid, password) => dispatch(processActions.setUserData(msisdn, pid, password)),
    resetUserData: () => dispatch(processActions.resetUserData()),
    checkPair: (msisdn, pid, token) => dispatch(processActions.checkPair(msisdn, pid, token)),
    processUser: (email, token, password, egn, id, addAddon) =>
      dispatch(processActions.processUser(email, token, password, egn, id, addAddon)),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(RegistrationStart);
